import { Avatar, Box, Flex, Icon } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import {
  locationValuemap,
  locationIconmap,
} from '@/pages/ats-job-creation/tabs/interview-plan/stage/activity/activity-sections/schedule-interview/helpers';
import { SCHEDULE_AI_COPY } from '../../constants';

const COPY = SCHEDULE_AI_COPY;

const LOCATIONS_WITH_NOTE_TAKER = ['google_meet', 'zoom', 'teams'];

const InterviewDetailRow = ({ label, children }) => (
  <Box mb="12px">
    <KText fontSize="13px" fontWeight="600" color="#413B74" mb="4px">
      {label}
    </KText>
    <Flex alignItems="center" gap="8px">
      {children}
    </Flex>
  </Box>
);

export const ReadOnlyDetails = ({ plan, interviewName = '' }) => {
  const interviewers = plan?.interviewers || plan?.participants || [];
  const duration = plan?.duration;
  const location = plan?.location;
  const kind = plan?.kind || plan?.interview_kind || 'one_on_one';
  const locationLabel = locationValuemap?.[location] || location;
  const LocationIcon = locationIconmap?.[location];
  const isPrivate = plan?.calendar_visibility === 'private';
  const noteTakerEnabled = plan?.note_taker_enabled === true;
  const displayName =
    interviewName || plan?.substituted_name || plan?.name || '';

  return (
    <Box>
      <InterviewDetailRow label="Interview name">
        <KText fontSize="14px" color="#413B74">
          {displayName}
        </KText>
      </InterviewDetailRow>
      <InterviewDetailRow label="Interview type">
        <KText fontSize="14px" color="#413B74">
          {kind === 'panel' ? 'Panel' : 'One on one'}
        </KText>
      </InterviewDetailRow>

      {interviewers.length > 0 && (
        <InterviewDetailRow label={COPY.interviewer}>
          {interviewers.map((p) => (
            <Flex key={p?.id} alignItems="center" gap="6px">
              <Avatar
                size="xs"
                name={p?.name}
                src={p?.avatar_url || p?.avatar}
              />
              <KText fontSize="14px" color="#413B74">
                {p?.name}
              </KText>
            </Flex>
          ))}
        </InterviewDetailRow>
      )}

      {duration && (
        <InterviewDetailRow label={COPY.duration}>
          <KText fontSize="14px" color="#413B74">
            {duration} mins
          </KText>
        </InterviewDetailRow>
      )}

      <InterviewDetailRow label={COPY.makeInterviewPrivate}>
        <KText fontSize="14px" color="#413B74">
          {isPrivate ? 'Yes' : 'No'}
        </KText>
      </InterviewDetailRow>

      {location && (
        <InterviewDetailRow label={COPY.location}>
          {LocationIcon && <Icon as={LocationIcon} w="16px" h="16px" />}
          <KText fontSize="14px" color="#413B74">
            {locationLabel}
          </KText>
        </InterviewDetailRow>
      )}

      {location === 'onsite' && (plan?.office_name ?? plan?.ats_office_id) && (
        <InterviewDetailRow label="Office Address">
          <KText fontSize="14px" color="#413B74">
            {plan.office_name ?? `Office #${plan.ats_office_id}`}
          </KText>
        </InterviewDetailRow>
      )}

      {LOCATIONS_WITH_NOTE_TAKER.includes(location) && (
        <InterviewDetailRow label={COPY.enableNoteTaker}>
          <KText fontSize="14px" color="#413B74">
            {noteTakerEnabled ? 'Yes' : 'No'}
          </KText>
        </InterviewDetailRow>
      )}
    </Box>
  );
};
